// Fraîcheur d'une donnée (D-022) : récente sous 24 h, ancienne de 24 à 72 h, périmée au-delà.
// Une donnée sans horodatage est considérée comme périmée. Seuils paramétrables par type d'installation.

import { SEUILS_FRAICHEUR_DEFAUT } from '../constantes';

export type Fraicheur = 'recente' | 'ancienne' | 'perimee';

export interface SeuilsFraicheur {
  recenteHeures: number;
  ancienneHeures: number;
}

export function evaluerFraicheur(
  horodatage: Date | string | null | undefined,
  maintenant: Date = new Date(),
  seuils: SeuilsFraicheur = SEUILS_FRAICHEUR_DEFAUT,
): Fraicheur {
  if (seuils.recenteHeures <= 0 || seuils.ancienneHeures < seuils.recenteHeures) {
    throw new Error('Seuils de fraîcheur incohérents');
  }
  if (horodatage === null || horodatage === undefined || horodatage === '') return 'perimee';
  const instant = horodatage instanceof Date ? horodatage : new Date(horodatage);
  if (Number.isNaN(instant.getTime())) return 'perimee';
  const ageHeures = (maintenant.getTime() - instant.getTime()) / 3_600_000;
  // Un horodatage légèrement dans le futur (décalage d'horloge) reste récent.
  if (ageHeures < seuils.recenteHeures) return 'recente';
  if (ageHeures <= seuils.ancienneHeures) return 'ancienne';
  return 'perimee';
}

export const LIBELLES_FRAICHEUR: Record<Fraicheur, string> = {
  recente: 'Récente',
  ancienne: 'Ancienne',
  perimee: 'Périmée',
};

/** Âge lisible d'une donnée, par exemple « il y a 3 h » ou « il y a 4 j ». */
export function formaterAge(horodatage: Date | string, maintenant: Date = new Date()): string {
  const instant = horodatage instanceof Date ? horodatage : new Date(horodatage);
  const minutes = Math.max(0, Math.round((maintenant.getTime() - instant.getTime()) / 60_000));
  if (minutes < 1) return 'à l’instant';
  if (minutes < 60) return `il y a ${minutes} min`;
  const heures = Math.round(minutes / 60);
  if (heures < 48) return `il y a ${heures} h`;
  return `il y a ${Math.round(heures / 24)} j`;
}
